export class GenPlantCountryEntity{
    id:number;
    countryId: number;
    plantId: number;
    description: number;
    active: boolean;
    constructor (){}
}